import React,{useContext} from 'react';
import {Card, CardHeader, CardContent, Typography, Grid, Divider } from '@material-ui/core';
import { ExpenseTrackerContext } from '../../context/context';
import useStyles from './styles';
import Form from './Form/Form';
import List from './List/List';
import infoCard from '../infoCard';
const Main = () => {
  const classes = useStyles();
  const {balance} = useContext(ExpenseTrackerContext);
  return (
    <Card className={classes.root}>
        <CardHeader title="Expense Tracker" />
        <CardContent>
            <Typography align='center' variant='h5'>${balance}</Typography>
            <Typography variant='subtitle2' style={{lineHeight:'1.8', MarginTop:'20px'}}>
                {/* <infocard /> */}
                Try saying: Add income for $100 in category salary for yesterday.
            </Typography>
            <Divider />
            <Form/>
        </CardContent>
        <CardContent className={classes.cardContent}>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <List />
                </Grid>
            </Grid>
        </CardContent>
    </Card>
  )
}

export default Main